import { render, staticRenderFns } from "./rolelist.vue?vue&type=template&id=74b63428&"
import script from "./rolelist.vue?vue&type=script&lang=js&"
export * from "./rolelist.vue?vue&type=script&lang=js&"
import style0 from "./rolelist.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports